import { BookingConfirmationTemplate } from "./booking-confirmation-template";
import { BookingFinalConfirmationTemplate } from "./booking-final-confirmation-template";
import { BookingReportTemplate } from "./booking-report-template";

export class BookingDocumentTemplate {

    constructor(
        public name: string,
        public content: BookingReportTemplate | BookingConfirmationTemplate | BookingFinalConfirmationTemplate
    ){}
}
